// Grouped client for Webpunch operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { DataFormActionResponse } from '../models/DataFormActionResponse';
import { CustomerReview } from '../models/CustomerReview';
import { UpdateCustomerReviewRequest } from '../models/UpdateCustomerReviewRequest';
import { CreateCustomerReviewRequest } from '../models/CreateCustomerReviewRequest';
import { CustomerReviewFields } from '../models/CustomerReviewFields';
import { FilterCustomerReviewRequest } from '../models/FilterCustomerReviewRequest';
import { DataviewCustomerReviewResponse } from '../models/DataviewCustomerReviewResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { DataFormActionResponseSerializer } from '../serializers/DataFormActionResponseSerializer';
import { CustomerReviewSerializer } from '../serializers/CustomerReviewSerializer';
import { UpdateCustomerReviewRequestSerializer } from '../serializers/UpdateCustomerReviewRequestSerializer';
import { CreateCustomerReviewRequestSerializer } from '../serializers/CreateCustomerReviewRequestSerializer';
import { FilterCustomerReviewRequestSerializer } from '../serializers/FilterCustomerReviewRequestSerializer';
import { DataviewCustomerReviewResponseSerializer } from '../serializers/DataviewCustomerReviewResponseSerializer';

/**
 * HTTP client for Webpunch operations
 *
 * Client for Webpunch operations
 */
export class WebpunchClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForCustomerReview(formName: string, objectId: string, provider?: string | null, rating?: number | null, name?: string | null, description?: string | null, respondedOn?: string | null, refsLeadId?: string | null, refsSfWorkOrderId?: string | null, role?: string | null, location?: any | null, locationDistance?: any | null, iconImage?: any | null, tags?: string[] | null, isActive?: boolean | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/webpunch.CustomerReview({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (provider !== undefined) {
      queryParams.append('Provider', String(provider));
    }
    if (rating !== undefined) {
      queryParams.append('Rating', String(rating));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (respondedOn !== undefined) {
      queryParams.append('RespondedOn', String(respondedOn));
    }
    if (refsLeadId !== undefined) {
      queryParams.append('Refs|LeadId', String(refsLeadId));
    }
    if (refsSfWorkOrderId !== undefined) {
      queryParams.append('Refs|SfWorkOrderId', String(refsSfWorkOrderId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (iconImage !== undefined) {
      queryParams.append('IconImage', String(iconImage));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeCustomerReview(formName: string, provider?: string | null, rating?: number | null, name?: string | null, description?: string | null, respondedOn?: string | null, refsLeadId?: string | null, refsSfWorkOrderId?: string | null, role?: string | null, location?: any | null, locationDistance?: any | null, iconImage?: any | null, tags?: string[] | null, isActive?: boolean | null, entityId?: string | null, id?: string | null, createdOn?: string | null, lastModifiedOn?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/webpunch.CustomerReview/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (provider !== undefined) {
      queryParams.append('Provider', String(provider));
    }
    if (rating !== undefined) {
      queryParams.append('Rating', String(rating));
    }
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (respondedOn !== undefined) {
      queryParams.append('RespondedOn', String(respondedOn));
    }
    if (refsLeadId !== undefined) {
      queryParams.append('Refs|LeadId', String(refsLeadId));
    }
    if (refsSfWorkOrderId !== undefined) {
      queryParams.append('Refs|SfWorkOrderId', String(refsSfWorkOrderId));
    }
    if (role !== undefined) {
      queryParams.append('Role', String(role));
    }
    if (location !== undefined) {
      queryParams.append('Location', String(location));
    }
    if (locationDistance !== undefined) {
      queryParams.append('LocationDistance', String(locationDistance));
    }
    if (iconImage !== undefined) {
      queryParams.append('IconImage', String(iconImage));
    }
    if (tags !== undefined) {
      queryParams.append('Tags', String(tags));
    }
    if (isActive !== undefined) {
      queryParams.append('IsActive', String(isActive));
    }
    if (entityId !== undefined) {
      queryParams.append('EntityId', String(entityId));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    if (createdOn !== undefined) {
      queryParams.append('CreatedOn', String(createdOn));
    }
    if (lastModifiedOn !== undefined) {
      queryParams.append('LastModifiedOn', String(lastModifiedOn));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterCustomerReview(request?: FilterCustomerReviewRequest | null, options?: { headers?: Record<string, string> }): Promise<CustomerReview[]> {
    const path = '/app/api/Object/webpunch.CustomerReview/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerReviewRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CustomerReviewSerializer.fromObject(item));
  }

  async createCustomerReview(request?: CreateCustomerReviewRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    const path = '/app/api/Object/webpunch.CustomerReview';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(CreateCustomerReviewRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async updateCustomerReview(objectId: string, request?: UpdateCustomerReviewRequest | null, options?: { headers?: Record<string, string> }): Promise<DataFormActionResponse> {
    let path = '/app/api/Object/webpunch.CustomerReview({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'PATCH',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(UpdateCustomerReviewRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataFormActionResponseSerializer.fromObject(data);
  }

  async deleteCustomerReview(objectId: string, fields?: CustomerReviewFields[] | null, ifUnmodifiedSince?: string | null, options?: { headers?: Record<string, string> }): Promise<CustomerReview> {
    let path = '/app/api/Object/webpunch.CustomerReview({objectId})'
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (fields !== undefined) {
      queryParams.append('fields', String(fields));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'DELETE',
      headers: {
        ...this.config.headers,
        ...(ifUnmodifiedSince !== undefined && { 'If-Unmodified-Since': String(ifUnmodifiedSince) }),
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return CustomerReviewSerializer.fromObject(data);
  }

  async recentCustomerReview(request?: FilterCustomerReviewRequest | null, options?: { headers?: Record<string, string> }): Promise<CustomerReview[]> {
    const path = '/app/api/Object/webpunch.CustomerReview/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerReviewRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => CustomerReviewSerializer.fromObject(item));
  }

  async dataViewCustomerReview(request?: FilterCustomerReviewRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewCustomerReviewResponse> {
    const path = '/app/api/Object/webpunch.CustomerReview/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterCustomerReviewRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewCustomerReviewResponseSerializer.fromObject(data);
  }

}
